import { useState } from "react";
import { useTranslation } from "react-i18next";

import { CompanyChoice } from "#modules/auth/infra/companyChoice";
import { JoinExistingCompany } from "#modules/auth/infra/connectUserCompany";
import { CreateNewCompany } from "#modules/auth/infra/createNewCompany";
import { Flex } from "#shared/view/components/Flex";
import { Paper } from "#shared/view/components/Paper";
import { Stack } from "#shared/view/components/Stack";
import { ThreeStepsStepper } from "#shared/view/components/Stepper";

export const SetCompanyPage = () => {
  const [step, setStep] = useState(1);

  const { t } = useTranslation();

  const handleCreateNewCompanyClick = () => {
    setStep(2);
  };

  const handleJoinExistingCompanyClick = () => {
    setStep(3);
  };

  return (
    <Paper style={styles.paper}>
      <Paper p="lg" shadow="lg">
        <Stack gap={"xs"} align="center">
          <Flex align="center" justify="center">
            <img alt="" src="/logo-fabera-login.png" width="139" height="60" />
          </Flex>
          <Flex align="center" justify="center">
            <ThreeStepsStepper
              active={2}
              firstStep={t("login.step1")}
              firstDescription={t("login.step1Description")}
              secondStep={t("login.step2")}
              secondDescription={t("login.step2Description")}
              finalStep={t("login.step3")}
              finalDescription={t("login.step3Description")}
            />
          </Flex>
          {step === 1 && (
            <CompanyChoice
              onCreateNewCompanyClick={handleCreateNewCompanyClick}
              onJoinExistingCompanyClick={handleJoinExistingCompanyClick}
            />
          )}
          {step === 2 && <CreateNewCompany onCreateCompanyClick={handleJoinExistingCompanyClick} />}
          {step === 3 && (
            <JoinExistingCompany handleCreateNewCompanyClick={handleCreateNewCompanyClick} />
          )}
        </Stack>
      </Paper>
    </Paper>
  );
};

const styles = {
  paper: {
    height: "100vh",
    width: "100wh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "var(--Blue-gradient, linear-gradient(103deg, #2955E2 1.95%, #0B267B 91.53%))",
  },
};
